var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("nav", [
    _c(
      "ol",
      { staticClass: "breadcrumb" },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "li",
          { key: index, staticClass: "breadcrumb-item" },
          [
            index < _vm.items.length - 1
              ? _c("ci-router-link", {
                  staticClass: "font-weight-semi",
                  attrs: {
                    to: item.link,
                    title: item.title,
                    label: item.title,
                  },
                })
              : _c("span", { domProps: { textContent: _vm._s(item.title) } }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }